const getCanonicalNanpPhoneNumber = (
  value?: string | null
): string | null => {
  const trimmedValue = (value || "").trim();

  if (!trimmedValue || !/^[0-9+().\s./-]+$/.test(trimmedValue)) {
    return null;
  }

  const plusMatches = trimmedValue.match(/\+/g) || [];
  if (
    plusMatches.length > 1 ||
    (plusMatches.length === 1 && !trimmedValue.startsWith("+1"))
  ) {
    return null;
  }

  const digits = trimmedValue.replace(/\D/g, "");
  if (digits.length === 10 && plusMatches.length === 0) {
    return digits;
  }

  return digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : null;
};

/**
 * Matches the app and public-directory contract: format only unambiguous
 * NANP numbers and preserve international, vanity, extension-bearing, short,
 * or multi-number values exactly as entered.
 */
export const formatMemberPhoneNumberForDisplay = (
  value?: string | null
): string => {
  const canonicalPhoneNumber = getCanonicalNanpPhoneNumber(value);

  return canonicalPhoneNumber
    ? `(${canonicalPhoneNumber.slice(0, 3)}) ${canonicalPhoneNumber.slice(
        3,
        6
      )}-${canonicalPhoneNumber.slice(6)}`
    : value || "";
};

/**
 * CMP Dashboard (24) L55-65 and Update Member Form (24) L41-50 global rule:
 * every staff phone or contact-number input except Ext. keeps 10 digits and
 * formats as (XXX) XXX-XXXX while the user types. A pasted number with a
 * leading country code 1 (11 digits) keeps its last 10 digits. Toll-Free and
 * Fax keep their own formats (memberTollFreeFax.ts). Inputs call this only on
 * a user edit, so a stored legacy value shows as saved until it is edited.
 */
export const formatStaffPhoneInput = (value?: string | null): string => {
  const allDigits = (value || "").replace(/\D/g, "");
  const digits = (allDigits.length === 11 && allDigits.startsWith("1")
    ? allDigits.slice(1)
    : allDigits
  ).slice(0, 10);

  if (!digits) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
